import {StyleSheet} from 'react-native'

import {colors} from '#/lib/styles'
import {atoms as a} from '#/alf'

export const styles = StyleSheet.create({
  bottomBarLegacy: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    borderTopWidth: StyleSheet.hairlineWidth,
    paddingLeft: 5,
    paddingRight: 10,
    zIndex: 50,
  },
  bottomBarLegacyWeb: a.fixed,
  ctrl: {
    flex: 1,
    minHeight: 48,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ctrlCompose: {
    flex: 1.1,
  },
  composePill: {
    width: 46,
    height: 36,
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  composePillActive: {
    transform: [{translateY: -0.5}],
  },
  notificationCount: {
    position: 'absolute',
    left: '54%',
    top: 6,
    backgroundColor: colors.blue3,
    paddingHorizontal: 4,
    paddingTop: 1,
    paddingBottom: 1,
    borderRadius: 10,
    zIndex: 1,
  },
  notificationCountWeb: {
    paddingTop: 2,
    paddingBottom: 2,
    borderRadius: 10,
  },
  notificationCountLight: {
    borderColor: colors.white,
  },
  notificationCountDark: {
    borderColor: colors.gray8,
  },
  notificationCountLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: colors.white,
    fontVariant: ['tabular-nums'],
  },
  hasNewBadge: {
    position: 'absolute',
    left: '56%',
    marginLeft: 4,
    top: 8,
    width: 8,
    height: 8,
    backgroundColor: colors.blue3,
    borderRadius: 6,
    zIndex: 1,
  },
  ctrlIcon: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  ctrlIconSizingWrapper: {},
  homeIcon: {},
  feedsIcon: {},
  searchIcon: {
    top: -1,
  },
  bellIcon: {},
  profileIcon: {
    borderRadius: 100,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  messagesIcon: {},
  onProfile: {
    borderWidth: 1,
    borderRadius: 100,
  },
})
